// src/pages/Dashboard.jsx
import React from "react";
import UserAccessSummary from "../components/layout/UserAccessSummary";

export default function Dashboard() {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-semibold text-slate-900">Dashboard</h1>
        <UserAccessSummary />
      </div>

      {/* Placeholder metrics */}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Card title="Containers Inbound (Mock)" value="--" />
        <Card title="Appointments Today (Mock)" value="--" />
        <Card title="Exceptions (Mock)" value="--" />
      </div>

      {/* Placeholder activity feed */}
      <div className="rounded-xl bg-white shadow p-4">
        <div className="mb-2 font-semibold">Recent Activities (Mock)</div>
        <p className="text-sm text-gray-600">
          This is a placeholder. We will hook mock data first, then real API.
        </p>
      </div>
    </div>
  );
}

function Card({ title, value }) {
  return (
    <div className="rounded-xl bg-white shadow p-4">
      <div className="text-sm text-gray-500">{title}</div>
      <div className="mt-1 text-2xl font-semibold">{value}</div>
    </div>
  );
}
